import { render, staticRenderFns } from "./producer_tasting_submitted_overview.vue?vue&type=template&id=976e4c8e&scoped=true"
import script from "./producer_tasting_submitted_overview.vue?vue&type=script&lang=js"
export * from "./producer_tasting_submitted_overview.vue?vue&type=script&lang=js"
import style0 from "./producer_tasting_submitted_overview.vue?vue&type=style&index=0&id=976e4c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976e4c8e",
  null
  
)

export default component.exports